// ============================================================================
// `@torre/entitlements` — qué puede usar cada quién en la plataforma.
// ============================================================================
// Tres capas, de afuera hacia adentro (épica #662):
//   1. Bandera global  — la plataforma lo prende o lo apaga para TODOS.
//   2. Licencia        — lo que la compañía compró.
//   3. Rol del tenant  — lo que el admin de la compañía reparte a cada rol.
//      Rol de plataforma (#804) — lo que un rol GLOBAL ve en toda compañía; se
//      cruza con el del tenant y gana lo más restrictivo.
//
// Este paquete sólo trae el catálogo, los tipos y la resolución pura. Leer las
// banderas, licencias y roles de Firestore es trabajo del backend.
// ============================================================================

export { CATALOG, CATALOG_VERSION } from "./catalog";
export { resolveEntitlements, defaultFlagState, catalogFor, statusIn, isForeign, isAvailable } from "./resolve";
export { TENANT_TABLES, TENANTS } from "./tenantDefaults";
export { validateCatalog, validateTenantTables } from "./validate";
export type {
  EntitlementKey,
  EntitlementKind,
  EntitlementNode,
  EntitlementOverrides,
  EntitlementStatus,
  FlagState,
  Grants,
  PlatformRoleGrants,
  Reason,
  ResolveInput,
  ResolveResult,
  TenantId,
  TenantTable,
  TenantTables,
} from "./types";

/** Llave de una app a partir de su id del sidebar (`truck-yard` → `app:truck-yard`). */
export const appKey = (appId: string) => `app:${appId}`;
/** Llave de una categoría a partir de su id del sidebar. */
export const categoryKey = (categoryId: string) => `cat:${categoryId}`;
/** Llave de un ítem de menú de una app. */
export const menuKey = (appId: string, itemId: string) => `menu:${appId}.${itemId}`;
